import React, { useEffect, useState } from 'react';
import CryptoJS from 'crypto-js';
import { fetchUserDetailsById, verifyOtp } from '../components/Api';
import '../App.css';
import * as colors from "../assets/css/Colors";
import whitedesktopimg1 from '../assets/img/do-digital-card/Do-Digital-Green-Desktop-1.webp';
import darkdesktopimg1 from '../assets/img/do-digital-card/Do-Digital-Orange-Desktop-1.webp';
import Userprofileimage from '../components/Userprofileimage';
import { Container, Row, Col, Form, Button, Modal } from "react-bootstrap";
import whitemobileimg1 from '../assets/img/do-digital-card/Do-Digital-Green-Mobile-1.webp';
import whitemobileimg2 from '../assets/img/do-digital-card/Do-Digital-Green-Mobile-2.webp';
import darkmobileimg1 from '../assets/img/do-digital-card/Do-Digital-Orange-Mobile-1.webp';

const DecodeCard = () => {
  const [userDetails, setUserDetails] = useState(null);
  const [error, setError] = useState(null);
  const secretKey = CryptoJS.enc.Utf8.parse('1234567890123456');
 const [username, setUsername] = useState(''); // Store the username
  const [otp, setOtp] = useState(''); // Store the OTP entered by the user
   const [isOtpModalVisible, setOtpModalVisible] = useState(false);
  const whitedesktopimg1URL = whitedesktopimg1;
  const darkdesktopimg1URL = darkdesktopimg1;
  const whitemobileimg1URL = whitemobileimg1;
  const whitemobileimg2URL = whitemobileimg2;
  const darkmobileimg1URL = darkmobileimg1;
  // Start color change auto function
  const [colorScheme, setColorScheme] = useState(
    window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  );
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e) => {
      setColorScheme(e.matches ? 'dark' : 'light');
    };
    mediaQuery.addEventListener('change', handleChange);
    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);
  // End color change auto function



  // Fetch and decrypt username from QR code
  useEffect(() => {
    const fetchQRCodeData = async () => {
      try {
        const qrCodeUrl = window.location.href;

        const url = new URL(qrCodeUrl);
        const encryptedId = decodeURIComponent(url.pathname.split('/').pop());
        const iv = CryptoJS.enc.Base64.parse(decodeURIComponent(url.searchParams.get('iv')));

        const decryptedBytes = CryptoJS.AES.decrypt(encryptedId, secretKey, {
          iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        });
        const decryptedId = decryptedBytes.toString(CryptoJS.enc.Utf8);

        console.log('Decrypted ID:', decryptedId);

        if (decryptedId) {
          setUsername(decryptedId); // Store the username
          await requestOtp(decryptedId); // Request OTP immediately
          setOtpModalVisible(true); // Show OTP modal
        } else {
          setError('Invalid QR code. Please scan a valid code.');
        }
      } catch (decryptionError) {
        console.error('Decryption Error:', decryptionError);
        setError('Invalid QR code or decryption failed. Please try again.');
      }
    };

    fetchQRCodeData();
  }, []);

  // Request OTP
  const requestOtp = async (id) => {
    try {
      const response = await fetchUserDetailsById(id); // API to request OTP
      if (response.status === 200) {
        alert('OTP sent successfully to your registered email.');
      }
    } catch (err) {
      console.error('Error requesting OTP:', err);
      setError('Failed to send OTP. Please try again.');
    }
  };

  // Verify OTP
  const handleVerifyOtp = async () => {
    try {
      const response = await verifyOtp(username, otp); // Call verifyOtp API
      setUserDetails(response.data.data); // Store user details
      alert('OTP Verified Successfully!');
      setOtpModalVisible(false); // Close OTP modal
    } catch (err) {
      console.error('Error verifying OTP:', err);
      setError('Failed to verify OTP. Please try again.');
    }
  };

  return (
    <div>
      {userDetails ? (
        <div className='user-card-style-in-admin-page Verifications-user-profile-data'>
          <div className="ud-cen-s3 ud-cen-s4 desktop-view">
            <div className="ud-payment ud-pro-link card-dassebord-user">
              <div className="popup-content-front">
                <div className="do-digital-back-img">
                  <img src={colorScheme === 'light' ? whitedesktopimg1URL : darkdesktopimg1URL} alt="sharp" />
                </div>
                <Row className="do-digital-card-data">
                  <Col sm={5}>
                    <div className="do-digital-card-data-user-profile">
                    {userDetails.user_profile && (
                        <Userprofileimage text={userDetails.user_profile} />
                      )}
                    </div>
                  </Col>
                  <Col sm={7}>
                    <div className="do-digital-card-data-user-name">
                      <p style={{ color: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color }}>
                        <span className='user-name-in-profile'>{userDetails.fname} {userDetails.lname} <span className='ander-line-user-name' style={{ background: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color }}></span></span>
                      </p>
                    </div>
                    <div className="do-digital-card-data-user-id-number">
                      <p style={{ color: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color }}>
                        <strong>ID NO.: {userDetails.dodigi_id}</strong>
                      </p>
                    </div>
                    <div className="do-digital-card-data-site">
                      <p style={{ color: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color }}>
                        card.dodigitals.in
                      </p>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>

          <div className="Verifications-user-profile-data-card-style-mobile-view mobile-view">
            <div className="do-digital-back-img-mobile-view">
              <img src={colorScheme === 'light' ? whitemobileimg1URL : darkmobileimg1URL} alt="sharp" />
            </div>
            <div className="do-digital-card-data-mobile-view">
              <div className="do-digital-card-data-user-profile-mobile-view">
              {userDetails.user_profile && (
                        <Userprofileimage text={userDetails.user_profile} />
                      )}
              </div>
              <div className="do-digital-card-data-user-name-mobile-view">
                <p style={{ color: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color }}>
                  <span className='user-name-in-profile-mobile-view'>{userDetails.fname} {userDetails.lname} <span className='ander-line-user-name' style={{ background: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color }}></span></span>
                </p>
              </div>
              <div className="do-digital-card-data-user-id-number-mobile-view">
                <p style={{ color: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color }}>
                  <strong>ID NO.: {userDetails.dodigi_id}</strong>
                </p>
              </div>
              <div className="do-digital-card-data-site-mobile-view">
              <p style={{ color: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color }}>
                     card.dodigitals.in
                   </p>
              </div>
            </div>
          </div>

          {userDetails.profession_card && (
            <div className="ud-cen-s3 ud-cen-s4">
              <div className="ud-payment ud-pro-link card-dassebord-user desktop-view">
                <div className="popup-content-front">
                  <div className="do-digital-back-img">
                    <img src={colorScheme === 'light' ? whitedesktopimg1URL : darkdesktopimg1URL} alt="sharp" />
                  </div>
                  <Row className="do-digital-card-data">
                    <Col sm={5}>
                      <div className="do-digital-card-data-user-profile">
                      {userDetails.user_profile && (
                        <Userprofileimage text={userDetails.user_profile} />
                      )}
                      </div>
                    </Col>
                    <Col sm={7}>
                      <div className="do-digital-card-data-user-name">
                        <p style={{ color: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color }}>
                          <span className='user-name-in-profile'>{userDetails.fname} {userDetails.lname} <span className='ander-line-user-name' style={{ background: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color }}></span></span>
                        </p>
                      </div>
                      <div className="do-digital-card-data-user-id-number">
                        <p style={{ color: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color }}>
                          <strong>ID NO.: {userDetails.profession_card.profession_id}</strong>
                        </p>
                      </div>
                      <div className="do-digital-card-data-site">
                        <p style={{ color: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color }}>
                          card.dodigitals.in
                        </p>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
              <div className="Verifications-user-profile-data-card-style-mobile-view mobile-view">
            <div className="do-digital-back-img-mobile-view">
              <img src={colorScheme === 'light' ? whitemobileimg1URL : darkmobileimg1URL} alt="sharp" />
            </div>
            <div className="do-digital-card-data-mobile-view">
              <div className="do-digital-card-data-user-profile-mobile-view">
              {userDetails.user_profile && (
                        <Userprofileimage text={userDetails.user_profile} />
                      )}
              </div>
              <div className="do-digital-card-data-user-name-mobile-view">
                <p style={{ color: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color }}>
                  <span className='user-name-in-profile-mobile-view'>{userDetails.fname} {userDetails.lname} <span className='ander-line-user-name' style={{ background: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color }}></span></span>
                </p>
              </div>
              <div className="do-digital-card-data-user-id-number-mobile-view">
              <p style={{ color: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color }}>
                          <strong>ID NO.: {userDetails.profession_card.profession_id}</strong>
                        </p>
              </div>
              <div className="do-digital-card-data-site-mobile-view">
              <p style={{ color: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color }}>
                     card.dodigitals.in
                   </p>
              </div>
            </div>
          </div>
            </div>
          )}




        </div>

      ) : error ? (
        <p style={{ color: 'red', textAlign: 'center', marginTop: '20px' }}>{error}</p>
      ) : (
        <p style={{ textAlign: 'center', marginTop: '20px' }}>Loading...</p>
      )}

       {/* OTP Modal */}
            <Modal show={isOtpModalVisible} onHide={() => setOtpModalVisible(false)}>
              <Modal.Header closeButton>
                <Modal.Title>Enter OTP</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <Form.Group controlId="formOtp">
                    <Form.Label>OTP</Form.Label>
                    <Form.Control
                      type="text"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                      placeholder="Enter OTP"
                    />
                  </Form.Group>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setOtpModalVisible(false)}>
                  Close
                </Button>
                <Button variant="primary" onClick={handleVerifyOtp}>
                  Submit
                </Button>
              </Modal.Footer>
            </Modal>
    </div>
  );
};

export default DecodeCard;